import { createNavigationContainerRef } from '@react-navigation/native'
import { RootStackParamList } from '@src/navigation/types'

export const navigationRef = createNavigationContainerRef<RootStackParamList>()

export const navigate = (name: string, params?: any) => {
  if (!navigationRef.isReady()) {
    return
  }

  navigationRef.navigate(name as any, params)
}

export const getCurrentRouteName = () => {
  if (!navigationRef.isReady()) {
    return undefined
  }

  const navigationState = navigationRef.current?.getRootState()

  return navigationState?.routes[navigationState.index].name
}
